
<script lang="ts" setup>
import useStaticData from '~/composables/useStaticData'
import PolicyTable from '@/domains/policy/components/policy-table/policy-table.vue'
import type { ICookiesData } from '@/domains/policy/types/cookie.types'

const { getItems } = useStaticData()
const { t, locale } = useI18n()
const data = await getItems(['policy']) as ICookiesData

useHead({
  title: t('pageTitles.cookies.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.cookies.meta'),
    },
  ],
  link: [
    {
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    },
    {
      rel: 'canonical',
      href: t(`pageTitles.cookies.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.cookies.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.cookies.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.cookies.canonical.pl'),
    },
  ],
})

</script>

<template>
  <div class="cookie-page">
    <UiPolicy
      v-if="data.cookies.terms.cookies"
      :title="$t('cookies.title')"
      :subtitle="$t('cookies.subtitle')"
      :policy="data.cookies.terms.cookies"
      :table-of-contents="true"
    >
      <template #before-heading-4>
        <PolicyTable
          :data="data.cookies.cookiesProvidersNecessery!"
        />
      </template>

      <template #before-heading-6>
        <PolicyTable
          :data="data.cookies.cookiesProvidersMarketing!"
        />
      </template>
      
      <template #before-heading-8>
        <PolicyTable
          :data="data.cookies.cookiesProvidersAnalytics!"
        />
      </template>
    </UiPolicy>
  </div>
</template>

<style lang="scss" scoped>
.cookie-page {
  &__paragraph {
    @include h10;
    padding-bottom: 4.8rem;
    color: $text-400;
  }

  :deep(.policy__content) {
    width: 100%;
  }

  :deep(.analitic-list-element-1) {
    &:before {
      content: '2'!important;
    }
  }

  :deep(.analitic-list-element-2) {
    &:before {
      content: '3'!important;
    }
  }

  &__content-block-heading {
      @include h9;
      margin-bottom: 3.2rem;

      @include atM {
        @include h8;
        margin-bottom: 2.8rem;
      }
    }

  @include atM {
    :deep(.policy__content) {
      width: calc(100% - 36rem - 1.6rem);
    }

    &__content-block-heading {
      @include h8;
      margin-bottom: 2.8rem;
    }
  }
}
</style>
